<template>
<div class="chat-body">
  <div class="search-wrap">
    <el-select size="mini" v-model="regionId" filterable placeholder="选择战区" clearable>
      <template  v-for="item in regionList">
        <el-option :key="item.value" :label="item.label" :value="item.value" />
        <template v-if="item.children && item.children.length > 0">
          <el-option v-for="item2 in item.children" :key="item2.value" :label="' - ' + item2.label" :value="item2.value" />
        </template>
      </template>
    </el-select>
    <el-select size="mini" v-model="projectId" filterable placeholder="选择项目" clearable>
      <el-option v-for="item in projectListFilter" :key="item.value" :label="item.label" :value="item.value">
      </el-option>
    </el-select>
    <el-select size="mini" v-model="ChatId" filterable placeholder="选择群" clearable>
      <el-option v-for="item in GroupListFilter" :key="item.chat_id" :label="item.name" :value="item.chat_id"></el-option>
    </el-select>
    <el-date-picker size="mini" v-model="dateSpan" type="daterange" align="right" value-format="yyyy-MM-dd" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" style="width: 300px">
    </el-date-picker>
    <el-button size="mini" type="primary text2" @click="search">搜索</el-button>
  </div>

  <div class="chart-title">活跃度分布</div>
  <div id="chart-all" class="chart-wrap"></div>

  <div class="chart-title">周活跃分布</div>
  <div id="chart-week" class="chart-wrap"></div>

  <div class="chart-title">日活跃分布</div>
  <div id="chart-day" class="chart-wrap"></div>

</div>
</template>

<script>

  import { Loading } from 'element-ui';
  import * as echarts from 'echarts';

export default {
  name: "ConversationGroupActive",
  data () {
    return {
      regionId: '',
      regionList: [],
      projectId: '',
      projectList: [],
      projectListFilter: [],
      dateSpan: this.getLastMonth(),
      ChatId: '',
      GroupList: [],
      GroupListFilter: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一天',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  //界面没出来前加载
  created() {
    this.getRegionList()
    this.getProjectList()
    this.getGroupList()
  },
  mounted() {

  },
  watch: {
    regionId(val) {
      this.onRegionChange(val)
    },
    projectId(val) {
      this.onProjectChange(val)
    }
  },
  //事件
  methods: {
    search() {
      if(this.ChatId == "") {
        this.$alert('请选择群', '提示', {
          type: 'warning'
        });
        return false;
      }
      if(this.dateSpan == "") {
        this.$alert('请选择日期。', '提示', {
          type: 'warning'
        });
        return false;
      }
      this.getData()
    },
    getProjectList() {
      this.$qwhttp.get('project/options', {}).then( res => {
        if(res.status == 200 && res.data.errcode == 0) {
          this.projectList = res.data.data
          this.projectListFilter = res.data.data
        }
      })
    },
    getRegionList() {
      this.$qwhttp.get('region/options', {}).then( res => {
        if(res.status == 200 && res.data.errcode == 0) {
          this.regionList = this.getRegionTree(0, res.data.data)
        }
      })
    },
    getRegionTree(id, d) {
      let list = []
      for(const k in d) {
        if(d[k].parent_id == id) {
          let item = d[k]
          item.children = this.getRegionTree(item.value, d)
          list.push(item)
        }
      }
      return list
    },
    onRegionChange(val) {
      this.projectListFilter = val ? this.projectList.filter(item => {
        return item.region_id == val
      }) : this.projectList
      this.projectId = ''
    },
    onProjectChange(val) {
      this.GroupListFilter = val ? this.GroupList.filter(item => {
        return item.project_id == val
      }) : this.GroupList
      this.ChatId = ''
    },
    getGroupList() {
      this.$qwhttp.get('group/options', {}).then( res => {
        if(res.status == 200 && res.data.errcode == 0) {
          this.GroupList = res.data.data
          //this.ChatId = 'wrtIkxCgAAUljo6Kfm-oNrMdGdtuCYxg'
          this.getData()
          this.getData('week')
          this.getData('day')
        }
      })
    },
    getData(type = '') {
      this.$qwhttp.get('group/active_analyze', {params: {type: type, chat_id: this.ChatId, start_date: this.dateSpan[0], end_date: this.dateSpan[1]}}).then( res => {
        if(res.status == 200 && res.data.errcode == 0) {
          switch(type) {
            case 'week' : this.createChartWeek(res.data.data); break;
            case 'day' : this.createChartDay(res.data.data); break;
            default: this.createChart(res.data.data)
          }

        }
      })
    },
    createChart(d) {

      let data = [];
      for(let k in d.dayList) {
        const v = d.data[d.dayList[k]]
        data.push(v ? v : 0)
      }

      let myChart = echarts.init(document.getElementById('chart-all'))
      myChart.setOption({
        visualMap: [
          {
            show: false,
            type: 'continuous',
          }
        ],
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          left: '2%',
          right: '60px',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            name: '日期',
            data: d.dayList,
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '互动次数',
            nameGap: 30,
            axisLabel: {
              formatter: '{value}'
            }
          },
        ],
        series: [
          {
            name: '互动次数',
            type: 'line',
            label: {
              show: true,
              fontWeight: 'bold',
              position: 'top'
            },
            data: data
          }
        ]
      });

    },
    createChartWeek(d) {

      let data = [];
      for(let k in d.dayList) {
        const v = d.data[d.dayList[k]]
        data.push(v ? v : 0)
      }

      // 测试数据
      // data = []
      // for(let i=0; i<7; i++) {
      //   data.push(Math.round(Math.random()*100 + 1))
      // }

      let myChart = echarts.init(document.getElementById('chart-week'))
      myChart.setOption({
        visualMap: [
          {
            show: false,
            type: 'continuous',
          }
        ],
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          left: '2%',
          right: '60px',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            name: '日期',
            data: d.dayList.map((item, index) => {
              return {
                value: item + "\n" + this.getWeekend(index),
                textStyle: {
                  height: 32,
                  lineHeight: 16
                }
              }
            }),
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '互动次数',
            nameGap: 30,
            axisLabel: {
              formatter: '{value}'
            }
          },
        ],
        series: [
          {
            name: '互动次数',
            type: 'bar',
            label: {
              show: true,
              fontWeight: 'bold',
              position: 'top'
            },
            data: data
          }
        ]
      });

    },
    createChartDay(d) {

      let data = [];
      for(let k in d.dayList) {
        const v = d.data[d.dayList[k]]
        data.push(v ? v : 0)
      }

      // 测试数据
      // data = []
      // for(let i=0; i<24; i++) {
      //   data.push(Math.round(Math.random()*50 + 1))
      // }

      let myChart = echarts.init(document.getElementById('chart-day'))
      myChart.setOption({
        visualMap: [
          {
            show: false,
            type: 'continuous',
          }
        ],
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          left: '2%',
          right: '60px',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            name: '时间',
            data: d.dayList,
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '互动次数',
            nameGap: 30,
            axisLabel: {
              formatter: '{value}'
            }
          },
        ],
        series: [
          {
            name: '互动次数',
            type: 'line',
            label: {
              show: true,
              fontWeight: 'bold',
              position: 'top'
            },
            data: data
          }
        ]
      });

    },

    getLastMonth() {
      let start = new Date()
      let end = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      return [this.dateFormat(start), this.dateFormat(end)]
    },

    dateFormat(date) {
      let m = date.getMonth() + 1
      let d = date.getDate()
      return date.getFullYear() + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d)
    },

    getWeekend(i) {
      return {
        0: '星期一',
        1: '星期二',
        2: '星期三',
        3: '星期四',
        4: '星期五',
        5: '星期六',
        6: '星期日',
      }[i]
    }

  }
}
</script>
<style scoped lang="scss">
.chat-body{
  box-sizing: border-box;
  position: relative;
  padding: 15px;
}

.text2 {
  color: #FFFFFF;
}

.search-wrap {
  padding-bottom: 15px;
  border-bottom: 1px solid #EBEEF5;
  display: flex;
  align-items: center;
  > * {
    margin-right: 5px
  }
}

.chart-wrap {
  margin-top: 20px;
  width: 100%;
  height: 300px;
  margin-bottom: 40px;
}

.chart-title {
  margin-top: 20px;
  font-size: 20px;
  font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Conversation/GroupActive.vue